import React from 'react';

import PropTypes from 'prop-types';

import { CollectionProvider } from './CollectionProvider';
import { SheetsCommonProvider } from './CommonProvider';
import { SearchPanelProvider } from './SearchPanelProvider';
import { SheetFilterProvider } from './SheetFilterProvider';

const SheetsProvider = ({ children, sheetContainerType, sheetParser }) => {
  return (
    <SheetsCommonProvider
      sheetContainerType={sheetContainerType}
      sheetParser={sheetParser}
    >
      <CollectionProvider>
        <SheetFilterProvider>
          <SearchPanelProvider>{children}</SearchPanelProvider>
        </SheetFilterProvider>
      </CollectionProvider>
    </SheetsCommonProvider>
  );
};

SheetsProvider.propTypes = {
  children: PropTypes.node,
  sheetContainerType: PropTypes.string,
  sheetParser: PropTypes.func,
};

SheetsProvider.displayName = 'SheetsProvider';

export default SheetsProvider;
